import { connect } from 'react-redux'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

import { MarketplaceUsersPage } from '@components/marketplaceUsers'

const mapDispatchToProps = () => {
  const { RestService, UIService } = services
  const {
    SearchIndexAccounts,
    LoadMarketplaceUsers,
    SearchDinerProfiles,
    SearchClientReportingPrograms,
    SendWelcomeEmail,
  } = coordinators
  const { pResponseGeneric, pResponseAccounts } = presenters.Api

  const loadAccounts = SearchIndexAccounts({ RestService, pResponseAccounts })
  const loadMarketplaceUsers = LoadMarketplaceUsers({
    RestService,
    pResponseMarketplaceUsers: pResponseGeneric,
  })
  const loadDinerProfiles = SearchDinerProfiles({ RestService, HandleError })
  const loadClientReportingPrograms = SearchClientReportingPrograms({
    RestService,
    HandleError,
  })
  const sendWelcomeEmail = SendWelcomeEmail({
    RestService,
    UIService,
    HandleError,
  })

  return {
    loadAccounts,
    loadMarketplaceUsers,
    loadDinerProfiles,
    loadClientReportingPrograms,
    sendWelcomeEmail,
  }
}

export default connect(undefined, mapDispatchToProps)(MarketplaceUsersPage)
